import { render, staticRenderFns } from "./CountryFeatures.vue?vue&type=template&id=404c3ff7&"
import script from "./CountryFeatures.vue?vue&type=script&lang=js&"
export * from "./CountryFeatures.vue?vue&type=script&lang=js&"
import style0 from "./CountryFeatures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports